import React from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { APP_URL_NOT_FOUND, ASTROLOGY_BASE_URL_PRIVACY, REVIEW_FORM_LINK } from '../../../const';
import { CheckRetinaDevice } from '../../../utils/helper';
import CreateNewChat, { createChatBtnType } from '../../common/CreateNewChat';
import Layout from '../../common/Layout/Layout';
import Spinner from '../../common/Spinner';
import Title from './Title';
import styles from './styled.module.scss';

const SingleLanding = ({
    loading,
    iconPath,
    advisor,
    altText,
    error,
    title,
    subtitle,
    advisorAlias,
    isActivity = false,
    activityId = null
}) => {
    const isRetina = CheckRetinaDevice();
    const navigation = useNavigate();
    const { t } = useTranslation();
    const getImagePathString = () => {
        if (isRetina && !isMobile) {
            return advisor?.images?.previewLarge;
        }
        if (isMobile) {
            return advisor?.images?.previewMobile;
        }
        return advisor?.images?.preview;
    };

    const imagePath = getImagePathString();

    if (!!error && (error.toString() === '404' || error.toString() === '400')) {
        navigation(`/${APP_URL_NOT_FOUND}`, { replace: true });
    }

    return (
        <>
            <Layout pageClassName={styles.home} innerContainerClassName={styles.container}>
                {loading && !error && <Spinner width={64} height={64} />}
                {!loading && !error && !!advisor && (
                    <>
                        {!!imagePath && (
                            <div className={styles.before}>
                                <img src={imagePath} alt={altText} />
                            </div>
                        )}
                        <div className={styles.wrapper}>
                            {!!iconPath && (
                                <div>
                                    <Title iconPath={iconPath} altText={altText} title={title} subtitle={subtitle} />
                                </div>
                            )}
                            <div>
                                <div className={styles.avatars}>
                                    <span>{t('labels.online')}</span>
                                </div>
                                <CreateNewChat
                                    activityId={activityId}
                                    isActivity={isActivity}
                                    type={createChatBtnType.advisorLanding}
                                    advisorAlias={advisorAlias}
                                    label={advisor?.strings?.callToAction || t('labels.calToAction')}
                                />
                            </div>
                            <div className={styles.privacy}>
                                <a href={REVIEW_FORM_LINK} className={styles.link} target="_blank">
                                    {t('buttons.feedback')}
                                </a>
                                <span></span>
                                <a href={ASTROLOGY_BASE_URL_PRIVACY} className={styles.link} target="_blank">
                                    {t('buttons.privacy')}
                                </a>
                            </div>
                        </div>
                    </>
                )}
            </Layout>
        </>
    );
};

export default SingleLanding;
